<div class="container-fluid content-wrapper pt-5" style="margin-top:3rem;">

    <div class="d-grid gap-2 d-md-flex mb-2 justify-content-md-end">
        <button type="button" class="btn btn-primary me-md-2" data-bs-toggle="modal" data-bs-target="#extraInfo" (click)="createmodeon()"><i class="bi bi-person-badge-fill"></i> Create New Borad User </button>
       
    </div>
    
    <div class="card">
      <div class="card-header">
       Board User's Info
      </div>
      <div class="card-body">
        <div *ngIf="showtable" style="height: 100%; box-sizing: border-box;">
            <ag-grid-angular
             #agGrid
              style="width: 100%; height:450px;"
              class="ag-theme-alpine"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [pagination]="true"
              [paginationPageSize]="10"
              [suppressRowClickSelection]="true"
              rowSelection="multiple"
              [rowData]="rowData[0]"
              [animateRows]="true"
           
            ></ag-grid-angular>
          </div>
          <div *ngIf="!showtable">
            <div class="alert alert-secondary text-center com-md-3">
              <p class="h5"><i class="bi bi-list-check"></i><br>No Users to Show</p>
          </div>
          </div>
      </div>
    </div>
    <!--Confidential work for Board Modal for extrta info about teacher -->
    <div class="modal fade" data-bs-backdrop="static" id="extraInfo" role="dialog">
      <div class="modal-dialog modal-xl">
    
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{actiontaken}} Board User </h4>
            <div *ngIf="actiontaken!='Create'" class="modenow" style="margin-left: -5rem;" (click)="toggleViewEdit()"><span style="font-size:1rem;font-size: 1rem;cursor: pointer;" class="text-danger">[{{currMode }}]</span><a class="editbtn"><i class="bi  text-danger" [ngClass]="frmdisable?'bi-pencil-square':'bi-eye-fill'"></i></a></div>
            <h4 type="button" class="close" data-bs-dismiss="modal" (click)="closemodal('extraInfo')">&times;</h4>
          </div>    
          <div class="modal-body">
            <!-- <div class="alert alert-success">
              Current teacher is associated with <strong>confidential duty</strong> for Board <a href="#" class="alert-link"></a>.
            </div> -->
            <form method="post" role="form" name="form2" #form="ngForm" [formGroup]="addboarduser" (ngSubmit)="getboarduserData(addboarduser.value)">
            <div class="row mb-3">
              <div class="col-md-12">
                <label for="inputEmail3" class="col-form-label">Full Name <span class="lr">*</span></label>
                <input type="text" name="full_name"  id="inputEmail3" class="form-control" [attr.disabled]="frmdisable?true:null" formControlName="full_name"  
                [ngClass]="{ 'is-invalid': submitted && f.full_name.errors }" />
                <div *ngIf="submitted && f.full_name.errors" class="invalid-feedback">
                <div *ngIf="f.full_name.errors.required">Name is required</div>
               </div>
              </div>                 
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="inputPassword3" class="col-form-label">Mobile Number <span class="lr">*</span></label>
                    <input  type="text" class="form-control" [attr.disabled]="frmdisable?true:null"  formControlName="mobile_no" 
                    [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }"  minlength="10" maxlength="10" />
                    <div *ngIf="submitted && f.mobile_no.errors" class="invalid-feedback">
                    <div *ngIf="f.mobile_no.errors.required">mobile Number is required</div>
                    <div *ngIf="f.mobile_no.errors.pattern">Please, Enter 10 digit mobile Number.</div>  
                    </div>
                </div>
                <div class="col-md-8">
                  <label for="inputPassword3" class="col-form-label">Email Address <span class="lr">*</span></label>
                  <input type="email" class="form-control" [attr.disabled]="updateuser?true:null"  formControlName="email_address"
                  [ngClass]="{ 'is-invalid': submitted && f.email_address.errors }" />
                  <div *ngIf="submitted && f.email_address.errors" class="invalid-feedback">
                  <div *ngIf="f.email_address.errors.required">Email Address is required</div>
                  <div *ngIf="f.email_address.errors.email">Email Address should be valid</div>
                  </div>
                </div>   
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="inputPassword3" class="col-form-label">Residence Address <span class="lr">*</span></label>
                  <input type="text" class="form-control" [attr.disabled]="frmdisable?true:null"  formControlName="address"
                  [ngClass]="{ 'is-invalid': submitted && f.address.errors }" />
                  <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                    <div *ngIf="f.address.errors.required">Residence Address is required</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="" >
                    <label  class="col-form-label">Current State<span>*</span></label>   
                    <select formControlName="board_cord_status" [attr.disabled]="frmdisable?true:null" 
                    [ngClass]="{ 'is-invalid': submitted && f.board_cord_status.errors }" class="form-select">
                          <option selected hidden [disabled]="true" value="">Select State</option>
                          <option value="Active">Active </option>
                          <option value="Deactive">Deactive</option>
                    </select>
                        <div *ngIf="submitted && f.board_cord_status.errors" class="invalid-feedback">
                            <div *ngIf="f.board_cord_status.errors.required">Status is required</div>
                        </div>
                  </div>
                </div>
              </div>
              <div class="row actions">
                <ul class="col-md-12" style="text-decoration: none; list-style: none;">
                  <li aria-hidden="false" aria-disabled="false">
                    <input type="submit" *ngIf="!updateuser" [attr.disabled]="frmdisable?true:null" value="Add Board-Coordinator" class="btn btn-warning  btn-block btnlogin  m-1">
                    <input type="submit" *ngIf="updateuser" [attr.disabled]="frmdisable?true:null" value="Update Board-Coordinator" class="btn btn-warning  btn-block btnlogin  m-1">
                   </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>



  <div *ngIf="proccessing" class="loadingcont">
    <div class="spinner"></div>
  </div>